import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { UserContext } from "../common/UserContext";
import axios from "axios";
import config from "../../envconfig";
import { FaBarcode, FaEye, FaInfoCircle, FaSearch } from "react-icons/fa";
import { Modal, Button, Table } from "react-bootstrap";
import { FaMapMarkerAlt } from "react-icons/fa";   // Solid map marker
import FullScreenSupplyChainMap from "./FullScreenSupplyChainMap";
import { use } from "react";
import { toast, ToastContainer } from "react-toastify";
import { IoCaretDownOutline, IoCaretUpOutline } from "react-icons/io5";

function SCT() {
    // const { UM_CompanyID } = useContext(UserContext);
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId, UM_UserType } = useContext(UserContext);
    console.log("UM_CompanyID", UM_CompanyID);

    const navigate = useNavigate();
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [products, setProducts] = useState([]);

    const [shipments, setShipments] = useState([]);
    const [showShipmentModal, setShowShipmentModal] = useState(false);

    const [rsnDetails, setRsnDetails] = useState([]);
    const [showRsnModal, setShowRsnModal] = useState(false);

    const [PSrsnDetails, setPSRsnDetails] = useState([]);
    const [showPSRsnModal, setShowPSRsnModal] = useState(false);

    const [rsnHistory, setRsnHistory] = useState([]);
    const [showRsnHistoryModal, setShowRsnHistoryModal] = useState(false);

    const [childRsn, setChildRsn] = useState([]);
    const [showChildRsnModal, setShowChildRsnModal] = useState(false);

    const [childRsnSP, setChildRsnSP] = useState([]);
    const [showChildRsnSPModal, setShowChildRsnSPModal] = useState(false);

    const [rsnLocationData, setRsnLocationData] = useState(null);
    const [loadingLocation, setLoadingLocation] = useState(false);

    const [showShipmentRsnHistoryModal, setShowShipmentRsnHistoryModal] = useState(false);
    const [showShipmentChildRsnModal, setShowShipmentChildRsnModal] = useState(false);

    const [rsnList, setRsnList] = useState([]);

    //  RSN search functionality
    const [rsnSearchInput, setRsnSearchInput] = useState("");
    const [searchedRsnData, setSearchedRsnData] = useState(null);
    const [loadingRsnSearch, setLoadingRsnSearch] = useState(false);

    // Transaction dropdown options
    const transactionOptions = [
        { value: "", label: "--Select--" },
        { value: "rsn", label: "RSN" },
        { value: "shipment", label: "Shipment" },
        { value: "product", label: "Product" },
    ];

    // ✅ Shipment RSN states
    const [showShipmentRSNModal, setShowShipmentRSNModal] = useState(false);
    const [shipmentRSNData, setShipmentRSNData] = useState([]);

    // New state for product list and search results
    const [productList, setProductList] = useState([]);
    const [showProductList, setShowProductList] = useState(false);
    const [shipProductId, setShipProductId] = useState([]);

    // ✅ New states for Shipment search functionality
    const [shipmentSearchInput, setShipmentSearchInput] = useState("");
    const [RSNSelectedProductID, setRSNSelectedProductID] = useState("");
    const [filteredShipments, setFilteredShipments] = useState([]);



    // Add new states for RSN input type
    const [rsnInputType, setRsnInputType] = useState("manual"); // "manual" or "scan"
    const [scanning, setScanning] = useState(false);


    // UPDATED: Handle QR scan and direct RSN history fetch - now supports both GS1 and simple RSN
    const handleScanRsnSearch = async () => {
        if (!rsnSearchInput.trim() && rsnInputType === "manual") {
            toast.error("Please Enter RSN");
            return;
        } else if (!rsnSearchInput.trim() && rsnInputType === "scan") {
            toast.error("Please Scan GS1 QR code");
            return;
        }

        setLoadingRsnSearch(true);
        const isQRData = rsnSearchInput.includes('(21)') && rsnSearchInput.includes('(01)');

        try {
            if (rsnInputType === "scan") {
                // Always use the scan API endpoint for both GS1 and simple RSN
                const response = await axios.get(
                    `${config.API_URL}/scan/rsnhistory/${encodeURIComponent(rsnSearchInput.trim())}/${UM_CompanyID}`
                );
                console.log("handleScanRsnSearch response:", response);

                if (response.data && response.data.success) {
                    if (response.data.multipleProducts) {
                        // Multiple products found for simple RSN - show product list
                        setProductList(response.data.products);
                        setShowProductList(true);
                        setSearchedRsnData(response.data.scannedData);
                    } else {
                        // Single product found - show RSN history directly
                        setRsnHistory(response.data.data);
                        setShowRsnHistoryModal(true);
                        setShowProductList(false);
                        setSearchedRsnData(response.data.scannedData);
                    }
                } else {
                    toast.error("No RSN history found");
                    setSearchedRsnData(null);
                    setShowProductList(false);
                }
            } else {
                // For manual input, use the existing search flow
                await handleRsnSearch();
            }
        } catch (error) {
            console.error("Error processing RSN search:", error);
            if (error.response?.status === 404) {
                if (rsnInputType === "scan" && isQRData) {
                    toast.error("No product found for the scanned GTIN or invalid QR format");
                } else {
                    toast.error("RSN not found");
                }
            } else if (error.response?.status === 400) {
                toast.error("Invalid QR format. Could not extract RSN and GTIN");
            } else {
                toast.error("Error processing RSN search. Please try again.");
            }
            setSearchedRsnData(null);
            setShowProductList(false);
        } finally {
            setLoadingRsnSearch(false);
        }
    };

    // UPDATED: Search RSN - now handles both manual and scan
    const handleRsnSearch = async () => {
        if (!rsnSearchInput.trim()) {
            toast.error("Please enter an RSN number");
            return;
        }
        setLoadingRsnSearch(true);
        try {
            const response = await axios.get(
                `${config.API_URL}/search/rsnhistory/${rsnSearchInput.trim()}/${UM_CompanyID}`
            );
            console.log("handleRsnSearch response:", response);

            if (response.data && response.data.success) {
                setSearchedRsnData(response.data.data);

                // Show product list with unique products
                if (response.data.uniqueProducts && response.data.uniqueProducts.length > 0) {
                    setProductList(response.data.uniqueProducts);
                    setShowProductList(true);
                } else {
                    toast.error("No products found for this RSN");
                    setRsnSearchInput('');
                    setShowProductList(false);
                }
            } else {
                toast.error("RSN not found");
                setSearchedRsnData(null);
                setShowProductList(false);
            }
        } catch (error) {
            console.error("Error searching RSN:", error);
            toast.error("Error searching RSN. Please try again.");
            setSearchedRsnData(null);
            setShowProductList(false);
        } finally {
            setLoadingRsnSearch(false);
        }
    };

    // UPDATED: Handle Enter key press
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleScanRsnSearch(); // Use the new combined function
        }
    };

    // UPDATED: Clear search when transaction type or input type changes
    useEffect(() => {
        setRsnSearchInput("");
        setSearchedRsnData(null);
        setShowProductList(false);
    }, [selectedOption, rsnInputType]);

    // Function to simulate scanning (you can integrate with actual scanner here)
    const handleSimulateScan = (type = "gs1") => {
        let sampleData;
        if (type === "gs1") {
            // GS1 QR code sample
            sampleData = "(21)365XGW1MYM44(01)18904091185402(17)260430(10)TB2053";
        } else {
            // Simple RSN sample
            sampleData = "RSN123456789";
        }

        setRsnSearchInput(sampleData);
        setScanning(true);

        // Auto-submit after a short delay to simulate scan completion
        setTimeout(() => {
            handleScanRsnSearch();
            setScanning(false);
        }, 1000);
    };

    // select product section start----------------------------------------------------
    // Load products for company
    useEffect(() => {
        if (UM_CompanyID) {
            axios
                .get(`${config.API_URL}/api/products/${UM_CompanyID}`)
                .then((res) => {
                    const options = res.data.map((p) => ({
                        value: p.PL_ProductId,
                        label: p.PL_ProductName,
                        PL_ProductCode: p.PL_ProductCode,
                    }));
                    setProducts(options);
                })
                .catch((err) => console.error(err));
        }
    }, [UM_CompanyID]);

    // Load shipments when product is selected
    const handleProductSelect = (product) => {
        setSelectedProduct(product);
        console.log("Selected product----------------:", product, product.value, UM_CompanyID, selectedScpId);
        console.log("Selected productID----------------:", product.PL_ProductCode);
        console.log("Selected UM_CompanyID----------------:", UM_CompanyID, selectedScpId);

        // Fetch shipments for the selected product
        if (product && product.PL_ProductCode) {
            console.log("Selected product----------------:", product, product.value, UM_CompanyID, selectedScpId);
            axios
                .get(
                    `${config.API_URL}/api/products/shipments/${UM_CompanyID}/${product.PL_ProductCode}`
                )
                .then((res) => {
                    const shipmentData = res.data.map((s) => ({
                        id: s.SHPD_ShipmentID,
                        code: s.SHPH_ShipmentCode,
                        date: s.SHPH_ShipmentDate,
                        status: s.SHPH_Status,
                        // Add other shipment fields as needed
                    }));
                    console.log("shipmentData--------------", shipmentData)
                    setShipments(shipmentData);
                    setShowShipmentModal(true); // Open the shipment modal
                })
                .catch((err) => console.error(err));
        }
    };
    // Handle view button click - navigate to shipment view page
    const handleViewShipment = (shipmentcode) => {
        // Save SCT state (your existing code)
        const stateToSave = {
            selectedOption,
            selectedProduct,
            products,
            shipments,
            rsnDetails,
            rsnSearchInput,
            shipmentSearchInput,
            filteredShipments,
            rsnList,
            showShipmentModal,
            showRsnModal
        };

        sessionStorage.setItem('sctState', JSON.stringify(stateToSave));

        // ⭐ add this flag
        sessionStorage.setItem("fromSCT", "yes");

        navigate(`/shipmentview/${shipmentcode}`);
    };
    useEffect(() => {
        sessionStorage.removeItem("fromSCT");
    }, []);


    // Load saved state from sessionStorage on component mount
    useEffect(() => {
        const savedState = sessionStorage.getItem('sctState');
        if (savedState) {
            try {
                const parsedState = JSON.parse(savedState);

                // Restore the state
                setSelectedOption(parsedState.selectedOption);
                setSelectedProduct(parsedState.selectedProduct);
                setProducts(parsedState.products || []);
                setShipments(parsedState.shipments || []);
                setRsnDetails(parsedState.rsnDetails || []);
                setRsnSearchInput(parsedState.rsnSearchInput || '');
                setShipmentSearchInput(parsedState.shipmentSearchInput || '');
                setFilteredShipments(parsedState.filteredShipments || []);
                setRsnList(parsedState.rsnList || []);
                setShowShipmentModal(parsedState.showShipmentModal || false); // Add this line
                setShowRsnModal(parsedState.showRsnModal || false); // Add this line

                // Clear the saved state so it doesn't persist on refresh
                sessionStorage.removeItem('sctState');
            } catch (error) {
                console.error('Error restoring state from sessionStorage:', error);
                // Clear corrupted data
                sessionStorage.removeItem('sctState');
            }
        }
    }, []);
    // Handle details button click - show RSN details
    const handleShowDetails = (shipmentId,) => {
        if (!selectedProduct) {
            console.error("No product selected");
            return;
        }
        console.log("slected product", selectedProduct, selectedScpId, shipmentId);
        console.log("slected SCPID", selectedScpId);
        axios
            .get(`${config.API_URL}/api/rsn/${UM_CompanyID}/${shipmentId}/${selectedProduct.value}`)
            .then((res) => {
                const rsnData = res.data.map((r) => ({
                    id: r.RSNH_ID,
                    randomNo: r.RSNH_RandomNo,
                    date: r.RSNH_TimeStamp,
                    status: r.RSNH_Status,
                    packsize: r.RSNH_PackSize,
                }));
                console.log("rsnData---------", rsnData);
                setPSRsnDetails(rsnData);
                setShowPSRsnModal(true);
                // setShowShipmentModal(false);
            })
            .catch((err) => console.error(err));
    };
    const handleShowShipProductRSNDetails = (productId,) => {
        if (!selectedShipmentCode) {
            console.error("No shipment selected");
            return;
        }
        console.log("slected shipment", selectedShipmentCode, productId);
        axios
            .get(`${config.API_URL}/api/rsn/${UM_CompanyID}/${selectedShipmentCode}/${productId}`)
            .then((res) => {
                const rsnData = res.data.map((r) => ({
                    id: r.RSNH_ID,
                    randomNo: r.RSNH_RandomNo,
                    date: r.RSNH_TimeStamp,
                    status: r.RSNH_Status,
                    packsize: r.RSNH_PackSize,
                }));
                console.log("rsnData---------", rsnData);
                setRsnDetails(rsnData);
                setShipProductId(productId);
                // setShowShipmentModal(false);
                setShowRsnModal(true);
            })
            .catch((err) => console.error(err));
    };

    const handleShowRSNDetails = async (RSNH_RandomNo) => {
        console.log("Selected Option:", selectedOption?.value);
        console.log("Shipment Product ID:", shipProductId);
        console.log("rsn Product ID:", RSNSelectedProductID);
        // console.log("selected Product ID:", selectedProduct.value);

        try {
            // Determine the correct API URL based on selectedOption
            let apiUrl = "";
            //   // ✅ Choose correct API URL based on selectedOption
            if (selectedOption?.value === "shipment") {
                if (!shipProductId) {
                    console.error("No shipment product selected");
                    return;
                }
                apiUrl = `${config.API_URL}/rsnhistory/${RSNH_RandomNo}/${UM_CompanyID}/${shipProductId}`;
            }
            else if (selectedOption?.value === "product") {
                if (!selectedProduct?.value) {
                    console.error("No product selected");
                    return;
                }
                apiUrl = `${config.API_URL}/rsnhistory/${RSNH_RandomNo}/${UM_CompanyID}/${selectedProduct.value}`;
            }
            else if (selectedOption?.value === "rsn") {
                if (!RSNSelectedProductID) {
                    console.error("No product selected");
                    return;
                }
                apiUrl = `${config.API_URL}/rsnhistory/${RSNH_RandomNo}/${UM_CompanyID}/${RSNSelectedProductID}`;
            }
            else {
                console.error("Invalid selection type");
                return;
            }

            console.log("Fetching RSN history from:", apiUrl);

            // Fetch API data
            const response = await fetch(apiUrl);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.success) {
                setRsnHistory(result.data);
                setShowRsnHistoryModal(true); // Open RSN History modal
            } else {
                setRsnHistory([]);
            }
        } catch (error) {
            console.error("Error fetching RSN history:", error);
            setRsnHistory([]);
        }
    };

    const handleShowShipProductRSNHistory = async (RSNH_RandomNo) => {
        if (!shipProductId) {
            console.error("No product selected");
            return;
        }
        console.log("slected product", selectedProduct, shipProductId);
        console.log("handleShowShipProductRSNHistory clicked with RSNH_RandomNo:", RSNH_RandomNo);
        try {
            const response = await fetch(
                `${config.API_URL}/rsnhistory/${RSNH_RandomNo}/${UM_CompanyID}/${shipProductId}`
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.success) {
                setRsnHistory(result.data);
                setShowRsnHistoryModal(true);  // open RSN History modal
            } else {
                setRsnHistory([]);
            }
        } catch (error) {
            console.error("Error fetching RSN history:", error);
            setRsnHistory([]);
        }
    };

    const handleViewChildRsn = async (RSNH_RandomNo) => {
        console.log("Handle View Child RSN clicked with RSNH_RandomNo:", RSNH_RandomNo);
        try {
            const response = await fetch(
                `${config.API_URL}/api/childrsn/${UM_CompanyID}/${RSNH_RandomNo}`
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            console.log("Child RSN API Response:", result);
            setChildRsn(result);
            setShowChildRsnModal(true);
            setShowRsnHistoryModal(false)


        } catch (error) {
            console.error("Error fetching child RSN:", error);
            setChildRsn([]);
        }
    };
    const handleViewChildRsnSP = async (RSNH_RandomNo) => {
        console.log("Handle View Child RSN clicked with RSNH_RandomNo:", RSNH_RandomNo);
        try {
            const response = await fetch(
                `${config.API_URL}/api/childrsn/${UM_CompanyID}/${RSNH_RandomNo}`
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            console.log("Child RSN API Response:", result);
            setChildRsnSP(result);
            setShowChildRsnSPModal(true);
            setShowRsnHistoryModal(false)


        } catch (error) {
            console.error("Error fetching child RSN:", error);
            setChildRsn([]);
        }
    };

    const closeRsnModal = () => {
        setShowRsnModal(false);
        setShowPSRsnModal(false);
    };
    const buildHistoryString = (data, key) => {
        const unique = [...new Set(
            data
                .map(item => {
                    if (!item[key]) return null;

                    // Special case for timestamp formatting
                    if (key === "RSNH_TimeStamp") {
                        return new Date(item[key]).toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                        });
                    }

                    return item[key];
                })
                .filter(Boolean)
        )];

        return unique.join(" --> ");
    };
    const handleOpenFullScreenMap = async (RSNH_RandomNo) => {
        console.log("RSNH_RandomNo-----------------", RSNH_RandomNo);
        setLoadingLocation(true);

        try {
            const response = await fetch(
                `${config.API_URL}/api/rsn-location/${RSNH_RandomNo}/${UM_CompanyID}`
            );
            console.log('Fetched RSN location data sct-----------------------:', response);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            console.log("result---------", result)
            if (result.success) {
                // Instead of setting state and opening modal, navigate to the new route
                // Pass the data via state or store it temporarily
                sessionStorage.setItem('rsnLocationData', JSON.stringify({
                    data: result.data,
                    rsnNumber: RSNH_RandomNo
                }));


                // Navigate to the full screen map component
                //   navigate(`/supply-chain-map/${RSNH_RandomNo}`);

                // ⭐ Open in a new tab
                window.open(`/supply-chain-map/${RSNH_RandomNo}`, "_blank");
            } else {
                toast.error('No location data found for this RSN');
            }
        } catch (error) {
            console.error("Error fetching RSN location data:", error);
            toast.error('Error fetching location data');
        } finally {
            setLoadingLocation(false);
        }
    };
    useEffect(() => {
        if (selectedOption?.value === "shipment" && UM_CompanyID) {
            axios
                .get(`${config.API_URL}/api/shipments/${UM_CompanyID}`)
                .then((res) => {
                    const shipmentData = res.data.map((s) => ({
                        id: s.SHPH_ShipmentID,
                        code: s.SHPH_ShipmentCode,
                        date: s.SHPH_ShipmentDate,
                        status: s.SHPH_Status,
                    }));
                    setShipments(shipmentData);
                })
                .catch((err) => console.error(err));
        }
    }, [selectedOption, UM_CompanyID]);

    useEffect(() => {
        if (selectedOption?.value === "shipment" && UM_CompanyID) {
            // 🚚 Shipment case
            axios
                .get(`${config.API_URL}/api/shipments/${UM_CompanyID}`)
                .then((res) => {
                    const shipmentData = res.data.map((s) => ({
                        id: s.SHPH_ShipmentID,
                        code: s.SHPH_ShipmentCode,
                        date: s.SHPH_ShipmentDate,
                        status: s.SHPH_Status,
                    }));
                    setShipments(shipmentData);
                })
                .catch((err) => console.error(err));
        }

        if (selectedOption?.value === "rsn" && UM_CompanyID) {
            // 📦 RSN case
            axios
                .get(`${config.API_URL}/api/SelectedRsn/rsn/${UM_CompanyID}`)
                .then((res) => {
                    const rsnData = res.data.map((r) => ({
                        id: r.RSNH_ID,
                        randomNo: r.RSNH_RandomNo,
                        created: r.RSNH_TimeStamp,
                        status: r.RSNH_Status,
                        packSize: r.RSNH_PackSize,
                    }));
                    setRsnList(rsnData); // <-- create this state
                })
                .catch((err) => console.error(err));
        }
    }, [selectedOption, UM_CompanyID]);



    // --- Shipment RSN handler ---
    const handleShowShipmentRSN = async (shipmentId) => {
        try {
            const res = await axios.get(
                `${config.API_URL}/api/shipment/rsn/${UM_CompanyID}/${shipmentId}`
            );
            setShipmentRSNData(res.data);
            setShowShipmentRSNModal(true);
        } catch (error) {
            console.error("Error fetching shipment RSN:", error);
        }
    };
    // Add these states to your component
    const [shipmentProducts, setShipmentProducts] = useState([]);
    const [showShipmentProductsModal, setShowShipmentProductsModal] = useState(false);
    const [selectedShipmentCode, setSelectedShipmentCode] = useState("");

    // Update your handleShowShipmentProductDetails function
    const handleShowShipmentProductDetails = async (shipmentId, shipmentCode) => {
        console.log("handleShowShipmentProductDetails clicked with shipmentId:", shipmentId, shipmentCode);
        try {
            const response = await fetch(
                `${config.API_URL}/api/shipment/products/${shipmentId}/${UM_CompanyID}`
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            console.log("handleShowShipmentProductDetails response:", response);

            const result = await response.json();
            console.log("result:", result);
            if (result.success) {
                setShipmentProducts(result.data);
                setSelectedShipmentCode(shipmentId);
                setShowShipmentProductsModal(true);
            } else {
                toast.error("No products found for this shipment");
            }
        } catch (error) {
            console.error("Error fetching shipment products:", error);
            toast.error("Error fetching shipment products");
        }
    };

    const handleShowShipmentRSNDetails = async (RSNH_RandomNo) => {
        console.log("handleShowShipmentRSNDetails clicked with RSNH_RandomNo:", RSNH_RandomNo);
        try {
            const response = await fetch(
                `${config.API_URL}/rsnhistorydetails/${RSNH_RandomNo}/${UM_CompanyID}`
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            console.log("handleShowShipmentRSNDetails response:", response);

            const result = await response.json();
            console.log("result:", result);
            if (result.success) {
                setRsnHistory(result.data);
                setShowShipmentRsnHistoryModal(true);  // open RSN History modal
            } else {
                setRsnHistory([]);
            }
        } catch (error) {
            console.error("Error fetching RSN history:", error);
            setRsnHistory([]);
        }
    };

    const handleViewShipmentChildRsn = async (RSNH_RandomNo) => {
        try {
            const response = await fetch(
                `${config.API_URL}/api/childrsn/${UM_CompanyID}/${RSNH_RandomNo}`
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            console.log("Child RSN API Response:", result);
            setChildRsn(result);
            setShowShipmentChildRsnModal(true);
            setShowChildRsnModal(true);


        } catch (error) {
            console.error("Error fetching child RSN:", error);
            setChildRsn([]);
        }
    };
    const handleProductDetails = async (product) => {
        try {
            const response = await axios.get(
                `${config.API_URL}/rsnhistory/${rsnSearchInput.trim()}/${UM_CompanyID}/${product.PL_ProductId}`
            );
            if (response.data && response.data.success) {
                setRsnHistory(response.data.data);
                setShowRsnHistoryModal(true);
                setRSNSelectedProductID(product.PL_ProductId)
                // setShowProductList(false);
            } else {
                toast.error("No history found for this product");
            }
        } catch (error) {
            console.error("Error fetching product RSN history:", error);
            toast.error("Error fetching product history");
        }
    };

    // ✅ Clear search when transaction type changes
    useEffect(() => {
        setRsnSearchInput("");
        setSearchedRsnData(null);
        setShowProductList(false);
    }, [selectedOption]);

    // ✅ Shipment search functionality

    useEffect(() => {
        if (!shipmentSearchInput.trim()) {
            // If search input is empty, show all shipments
            setFilteredShipments(shipments);
            return;
        }

        const filtered = shipments.filter(shipment =>
            shipment.code.toLowerCase().includes(shipmentSearchInput.toLowerCase())
        );
        setFilteredShipments(filtered);
    }, [shipmentSearchInput, shipments]);

    // ✅ Clear shipment search when transaction type changes
    useEffect(() => {
        setShipmentSearchInput("");
        setFilteredShipments(shipments);
    }, [selectedOption, shipments]);
    const [isSelectOpen, setIsSelectOpen] = useState(false);
    const handleSelectOpen = (selectName) => {
        setIsSelectOpen(selectName);
    };

    const handleSelectClose = () => {
        setIsSelectOpen(null);
    };
    return (
        <>
            <ToastContainer style={{
                marginTop: '73px',
                fontSize: '14px',
                width: '40%',
            }} />
            <div className="main_container">
                <h3 className="formHeading">Supply Chain Transaction</h3>
                <div className="col-md-12">
                    <div className="row">
                        {/* Transaction Type Dropdown */}
                        <div className="col-md-3">
                            <label className="mb-2">Transaction Type</label>
                            <div className="select-container_list">
                                <Select
                                    className="routing_select-box"
                                    placeholder="--Select--"
                                    options={transactionOptions}
                                    value={selectedOption}
                                    onChange={(option) => {
                                        setSelectedOption(option);
                                        setSelectedProduct(null);
                                        setShipments([]);
                                        setRsnDetails([]);
                                        setPSRsnDetails([]);
                                        setShowShipmentModal(false);
                                        setShowProductList(false);
                                    }}
                                    onMenuOpen={() => handleSelectOpen('TracnsactionType')}
                                    onMenuClose={handleSelectClose}
                                />
                                <div className='icon-container'>
                                    {isSelectOpen === 'TracnsactionType' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                </div>
                            </div>
                        </div>

                        {/* Product Dropdown - shown when transaction type is product */}
                        {selectedOption?.value === "product" && (
                            <div className="col-md-3">
                                <label className="mb-2">Product</label>
                                <div className="select-container_list">
                                    <Select
                                        className="routing_select-box"
                                        placeholder="--Select--"
                                        options={products}
                                        value={selectedProduct}
                                        onChange={(option) => handleProductSelect(option)}
                                        onMenuOpen={() => handleSelectOpen('productName')}
                                        onMenuClose={handleSelectClose}
                                        maxMenuHeight={170}
                                    />
                                    <div className='icon-container'>
                                        {isSelectOpen === 'productName' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* ==========================
                       PRODUCT MODAL START
                    ========================== */}
                        {/* Shipment Modal */}
                        {showShipmentModal && (
                            <div className="ptable-wrapper mt-3">
                                <table className="ptableClass">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Shipment Code</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {shipments.length > 0 ? (
                                            shipments.map((shipment, index) => (
                                                <tr key={shipment.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{shipment.code}</td>
                                                    <td className="d-flex justify-content-center  gap-2">
                                                        <FaEye size={20} onClick={() => handleViewShipment(shipment.code)}
                                                            title="View Shipment" />
                                                        <FaInfoCircle size={20}
                                                            onClick={() => handleShowDetails(shipment.id)}
                                                            title="RSN Details" />
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center">
                                                    No Records Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {/* RSN Details Modal */}
                        <Modal backdrop="static" centered show={showPSRsnModal} onHide={closeRsnModal} size="lg">
                            <Modal.Header closeButton>
                                <Modal.Title
                                    style={{ fontSize: '20px', color: '#465a64', fontWeight: 'bold' }}
                                >RSN Details </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="modal-body" style={{ padding: '0px', marginBottom: '0px' }}>
                                    <table className="tableClass mt-0">
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>RSN Number</th>
                                                <th>RSN Pack Size</th>
                                                <th>Action</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {PSrsnDetails.length > 0 ? (
                                                PSrsnDetails.map((rsn, index) => (
                                                    <tr key={rsn.id}>
                                                        <td>{index + 1}</td>
                                                        <td>{rsn.randomNo}</td>
                                                        <td>{rsn.packsize}</td>
                                                        <td className="d-flex justify-content-center  gap-2">
                                                            <FaInfoCircle size={20}
                                                                onClick={() => handleShowRSNDetails(rsn.randomNo)}
                                                                title="RSN Details" />
                                                            {rsn.packsize > 1 &&
                                                                <FaEye size={20}
                                                                    onClick={() => handleViewChildRsn(rsn.randomNo)}
                                                                    title="View Child RSNs" />
                                                            }
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className="text-center">
                                                        No Records Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </Modal.Body>
                        </Modal>

                        {/* RSN History Modal */}
                        <Modal backdrop="static" centered show={showRsnHistoryModal} onHide={() => setShowRsnHistoryModal(false)} size="lg">
                            <Modal.Header closeButton>
                                <Modal.Title
                                    style={{ fontSize: '20px', color: '#465a64', fontWeight: 'bold' }}
                                >RSN History
                                    {/* {rsnHistory[0]?.RSNH_RandomNo} */}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {rsnHistory.length > 0 ? (
                                    <table className="tableClass">
                                        <tbody>
                                            <tr>
                                                <td><strong>Product Name</strong></td>
                                                <td>{rsnHistory[0]?.PL_ProductName || "-"}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Pack Size</strong></td>
                                                <td>{rsnHistory[0]?.RSNH_PackSize || "-"}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Location History</strong></td>
                                                <td>{buildHistoryString(rsnHistory, "physical_location_name") || "-"}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Shipment History</strong></td>
                                                <td>{buildHistoryString(rsnHistory, "SHPH_ShipmentCode") || "-"}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Parent History</strong></td>
                                                <td>{buildHistoryString(rsnHistory, "RSNH_ParentRandomNo") || "-"}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Time Stamp</strong></td>
                                                <td>{buildHistoryString(rsnHistory, "RSNH_TimeStamp") || "-"}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Product History</strong></td>
                                                <td>
                                                    <FaMapMarkerAlt size={20} color="#465a64" title="Location"
                                                        onClick={() => handleOpenFullScreenMap(rsnHistory[0]?.RSNH_RandomNo)}
                                                    />
                                                </td>

                                            </tr>
                                            {rsnHistory[0]?.RSNH_PackSize > 1 && (
                                                <tr>
                                                    <td><strong>View child RSNs</strong></td>
                                                    <td>
                                                        <FaEye size={20}
                                                            onClick={() => handleViewChildRsn(rsnHistory[0]?.RSNH_RandomNo)}
                                                            title="View Child RSNs" />
                                                    </td>
                                                </tr>
                                            )}

                                        </tbody>
                                    </table>
                                ) : (
                                    <p className="text-center">No Records Found</p>
                                )}
                            </Modal.Body>
                        </Modal>
                        {/* Child RSN Modal */}
                        <Modal centered show={showChildRsnModal} onHide={() => setShowChildRsnModal(false)} size="md" backdrop="static">
                            <Modal.Header closeButton>
                                <Modal.Title
                                    style={{ fontSize: '20px', color: '#465a64', fontWeight: 'bold' }}
                                >Child RSNs</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="table-responsive">
                                    <table className="tableClass">
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>RSN Number</th>
                                                <th>Pack Size</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        {childRsn.length > 0 ? (
                                            <tbody>
                                                <>
                                                    {childRsn.map((child, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{child.RSNH_RandomNo}</td>
                                                            <td>{child.RSNH_PackSize}</td>
                                                            <td className="d-flex justify-content-center  gap-2">
                                                                <FaInfoCircle size={20}
                                                                    onClick={() => handleShowRSNDetails(child.RSNH_RandomNo)}
                                                                    title="RSN Details" />
                                                                {child.RSNH_PackSize > 1 &&
                                                                    <FaEye size={20}
                                                                        onClick={() => handleViewChildRsn(child.RSNH_RandomNo)}
                                                                        title="View Child RSNs" />
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </>
                                            </tbody>
                                        ) : (
                                            <tbody >
                                                <tr>
                                                    <td colSpan="4">No Records Found</td>
                                                </tr>
                                            </tbody>

                                        )}

                                    </table>
                                </div>

                            </Modal.Body>
                            <Modal.Footer style={{ borderTop: 'none', marginTop: '0px', paddingTop: '0px' }}>
                            </Modal.Footer>
                        </Modal>
                        {/* Location Map Modal */}

                        {/* ==========================
                           PRODUCT MODAL END
                        ========================== */}
                        {/* ******************************************************************************************************* */}
                        {/*  Shown data when transaction type is shipment */}
                        {selectedOption?.value === "shipment" && (
                            <div className="col-md-3">
                                <label className="mb-2">Shipment Code</label>
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="search-input"
                                        placeholder="Search Shipment Code"
                                        value={shipmentSearchInput}
                                        onChange={(e) => setShipmentSearchInput(e.target.value)}
                                    />
                                </div>
                            </div>
                        )}
                        {/*  Shipment List */}
                        {selectedOption?.value === "shipment" && (
                            // <div className="col-md-12 mt-3">
                            <div className="ptable-wrapper mt-3">
                                <table className="ptableClass">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Shipment Code</th>

                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredShipments.length > 0 ? (
                                            filteredShipments.map((shipment, index) => (
                                                <tr key={shipment.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{shipment.code}</td>
                                                    <td className="d-flex justify-content-center gap-2">
                                                        <FaEye size={20} onClick={() => handleViewShipment(shipment.code)}
                                                            title="View Shipment" />
                                                        <FaInfoCircle size={20}
                                                            onClick={() => handleShowShipmentProductDetails(shipment.id, shipment.code)}
                                                            title="RSN Details" />
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center">
                                                    {shipments.length > 0 ? 'No Records Found' : 'No Records Found'}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            // </div>
                        )}
                        {/* ==========================
                            SHIPMENT MODAL Start
                        ========================== */}
                        <Modal
                            backdrop="static"
                            centered
                            show={showShipmentProductsModal}
                            onHide={() => setShowShipmentProductsModal(false)}
                            size="lg"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title
                                    style={{ fontSize: '20px', color: '#465a64', fontWeight: 'bold' }}
                                >
                                    Products Details
                                    {/* {selectedShipmentCode} */}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {shipmentProducts.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="tableClass">
                                            <thead className="">
                                                <tr>
                                                    <th>Sr. No.</th>
                                                    <th>Product Code</th>
                                                    <th>Product Name</th>
                                                    <th>GTIN</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {shipmentProducts.map((product, index) => (
                                                    <tr key={product.PL_ProductId || index}>
                                                        <td>{index + 1}</td>
                                                        <td>{product.PL_ProductCode || product.SHPD_ProductCode || '-'}</td>
                                                        <td>{product.PL_ProductName || product.SHPD_ProductName || '-'}</td>
                                                        <td>{product.PL_GTIN || '-'}</td>
                                                        <td className="">
                                                            <FaInfoCircle size={20}
                                                                onClick={() => handleShowShipProductRSNDetails(product.PL_ProductId)}
                                                                title="RSN Details" />

                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="alert alert-info text-center">
                                        <FaInfoCircle className="me-2" />
                                        No Records Found
                                    </div>
                                )}
                            </Modal.Body>
                        </Modal>
                        {/* Shipment RSN List Modal */}
                        <Modal
                            show={showShipmentRSNModal}
                            onHide={() => setShowShipmentRSNModal(false)}
                            size="lg"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>Shipment RSN List</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {shipmentRSNData.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="tableClass">
                                            <thead>
                                                <tr>
                                                    <th>Sr. No.</th>
                                                    <th>RSN Random No</th>
                                                    <th>Pack Size</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {shipmentRSNData.map((rsn, index) => (
                                                    <tr key={rsn.RSNH_ID}>
                                                        <td>{index + 1}</td>
                                                        <td>{rsn.RSNH_RandomNo}</td>
                                                        <td>{rsn.RSNH_PackSize}</td>
                                                        <td className="d-flex justify-content-center  gap-2">
                                                            <FaInfoCircle size={20}
                                                                onClick={() => handleShowShipmentRSNDetails(rsn.RSNH_RandomNo)}
                                                                title="RSN Details" />
                                                            {rsn.RSNH_PackSize > 1 &&
                                                                <FaEye size={20}
                                                                    onClick={() => handleViewChildRsn(rsn.RSNH_RandomNo)}
                                                                    title="View Child RSNs" />
                                                            }
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <p>No Records Found</p>
                                )}
                            </Modal.Body>
                        </Modal>

                        {/* Child RSN Modal */}
                        <Modal centered show={showChildRsnSPModal} onHide={() => setShowChildRsnSPModal(false)} size="md" backdrop="static">
                            <Modal.Header closeButton>
                                <Modal.Title
                                    style={{ fontSize: '20px', color: '#465a64', fontWeight: 'bold' }}
                                >Child RSNs</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="table-responsive">
                                    <table className="tableClass">
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>RSN Number</th>
                                                <th>Pack Size</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        {childRsnSP.length > 0 ? (
                                            <tbody>
                                                <>
                                                    {childRsnSP.map((child, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{child.RSNH_RandomNo}</td>
                                                            <td>{child.RSNH_PackSize}</td>
                                                            <td className="d-flex justify-content-center  gap-2">
                                                                <FaInfoCircle size={20}
                                                                    onClick={() => handleShowShipProductRSNHistory(child.RSNH_RandomNo)}
                                                                    title="RSN Details" />
                                                                {child.RSNH_PackSize > 1 &&
                                                                    <FaEye size={20}
                                                                        onClick={() => handleViewChildRsnSP(child.RSNH_RandomNo)}
                                                                        title="View Child RSNs" />
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </>
                                            </tbody>
                                        ) : (
                                            <tbody >
                                                <tr>
                                                    <td colSpan="4">No Records Found</td>
                                                </tr>
                                            </tbody>

                                        )}

                                    </table>
                                </div>

                            </Modal.Body>
                            <Modal.Footer style={{ borderTop: 'none', marginTop: '0px', paddingTop: '0px' }}>
                            </Modal.Footer>
                        </Modal>

                        {/* ==========================
                          SHIPMENT MODAL End
                        ========================== */}
                        {/* ******************************************************************************************************* 
                    {/*  RSN Search Box - shown when transaction type is RSN */}
                        {/* RSN Search Section with Radio Buttons */}
                        {selectedOption?.value === "rsn" && (
                            <>
                                {/* Radio Buttons for Input Type */}
                                <div className="col-md-3 ">

                                    <div className="form-chec form-check-inlin d-flex">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="rsnInputType"
                                            id="manualInput"
                                            value="manual"
                                            checked={rsnInputType === "manual"}
                                            onChange={(e) => setRsnInputType(e.target.value)}
                                        />
                                        <label className="form-check-label mb-2" htmlFor="manualInput" style={{ width: '40px' }}>
                                            Manual
                                        </label>
                                        {/* </div>
                                <div className="form-chec form-check-inlin"> */}
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="rsnInputType"
                                            id="scanInput"
                                            value="scan"
                                            checked={rsnInputType === "scan"}
                                            onChange={(e) => setRsnInputType(e.target.value)}
                                        />
                                        <label className="form-check-label mb-2" htmlFor="scanInput">
                                            Scan
                                        </label>
                                    </div>
                                    {/* </div> */}

                                    {/* Search Input Field */}
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control search-input"
                                            placeholder={
                                                rsnInputType === "manual"
                                                    ? "Enter RSN"
                                                    : "Scan GS1 QR code"
                                            }
                                            value={rsnSearchInput}
                                            onChange={(e) => setRsnSearchInput(e.target.value)}
                                            onKeyPress={handleKeyPress}
                                            autoFocus
                                            style={{
                                                backgroundColor: rsnInputType === "scan" ? "#f5f5f5" : "white",
                                                cursor: rsnInputType === "scan" ? "not-allowed" : "text",
                                            }}
                                            
                                            // onKeyDown={(e) => {
                                            //     // ❌ Disable typing keys in scan mode
                                            //     if (rsnInputType === "scan") {
                                            //         const blockedKeys = [
                                            //             ...Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i)), // A–Z
                                            //             ...Array.from({ length: 10 }, (_, i) => i.toString()), // 0–9
                                            //         ];

                                            //         if (blockedKeys.includes(e.key.toUpperCase())) {
                                            //             e.preventDefault();
                                            //             return;
                                            //         }
                                            //     }

                                            //     // Press Enter to search
                                            //     if (e.key === "Enter") {
                                            //         handleScanRsnSearch();
                                            //     }
                                            // }}
                                        />
                                        <button
                                            className="searchiconbtn "
                                            type="button"
                                            onClick={handleScanRsnSearch}
                                            disabled={loadingRsnSearch}
                                        >
                                            {loadingRsnSearch ? (
                                                "Searching..."
                                            ) : rsnInputType === "scan" ? (
                                                <FaBarcode />
                                            ) : (
                                                <FaSearch />
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}

                        {/* Rest of your existing JSX remains the same */}
                        {/* Product List Table - shown after manual RSN search */}
                        {showProductList && rsnInputType === "manual" && (
                            <div className="col-md-12 mt-3">
                                <h5 style={{ fontWeight: "bold", color: "#465a64" }}> RSN : {rsnSearchInput}</h5>
                                <div className="ptable-wrapper">
                                    <table className="ptableClass">
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>GTIN</th>
                                                <th>Product Code</th>
                                                <th>Product Name</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {productList.length > 0 ? (
                                                productList.map((product, index) => (
                                                    <tr key={product.PL_ProductId}>
                                                        <td>{index + 1}</td>
                                                        <td>{product.PL_GTIN || "-"}</td>
                                                        <td>{product.PL_ProductCode || "-"}</td>
                                                        <td>{product.PL_ProductName || "-"}</td>
                                                        <td className="d-flex justify-content-center gap-2">
                                                            <FaInfoCircle size={20}
                                                                onClick={() => handleProductDetails(product)}
                                                                title="RSN Details" />
                                                            <FaMapMarkerAlt size={20} color="#465a64" title="Location"
                                                                onClick={() => handleOpenFullScreenMap(rsnSearchInput)}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">
                                                        No Records Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* Display scanned data info when in scan mode */}
                        {/* Shipment Product RSN History Modal */}
                        <Modal backdrop="static" centered show={showRsnModal} onHide={closeRsnModal} size="lg">
                            <Modal.Header closeButton>
                                <Modal.Title
                                    style={{ fontSize: '20px', color: '#465a64', fontWeight: 'bold' }}
                                >RSN Details</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="modal-body" style={{ padding: '0px', marginBottom: '0px' }}>
                                    <table className="tableClass mt-0">
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>RSN Number</th>
                                                <th>RSN Pack Size</th>
                                                <th>Action</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rsnDetails.length > 0 ? (
                                                rsnDetails.map((rsn, index) => (
                                                    <tr key={rsn.id}>
                                                        <td>{index + 1}</td>
                                                        <td>{rsn.randomNo}</td>
                                                        <td>{rsn.packsize}</td>
                                                        <td className="d-flex justify-content-center  gap-2">
                                                            <FaInfoCircle size={20}
                                                                onClick={() => handleShowShipProductRSNHistory(rsn.randomNo)}
                                                                title="RSN Details" />
                                                            {rsn.packsize > 1 &&
                                                                <FaEye size={20}
                                                                    onClick={() => handleViewChildRsnSP(rsn.randomNo)}
                                                                    title="View Child RSNs" />
                                                            }
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className="text-center">
                                                        No Records Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SCT;
